module.exports = __webpack_public_path__ + "img/cloud_3.f25ae65f.png";